import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import s from './ElectionState.scss';
import RenderChartLoadable from '../Charts/RenderChartLoadable';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import DataBar from '../../../../../components/ElectionV2/common/DataBar/DataBar';
import ElectionBattle from '../../../../../components/ElectionV2/common/ElectionBattle/ElectionBattle';
import LiveblogUpdates from '../../../../../components/ElectionV2/common/LiveblogUpdates/LiveblogUpdates';
import AlliancePopup from '../../../../../components/ElectionV2/common/AlliancePopup/AlliancePopup';

class ElectionState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exitPollSource: [],
      selectedSource: '',
      // sortedPartyViewData: [],
      // sortedAllianceViewData: [],
      activeTab: 1,
      finalSourceData: {},
    };
    if (this.props.isExitPoll) {
      this.getSourceDataforExitPoll();
    }
  }
  componentDidMount() {
    this.allianceInfoWrapperRef = React.createRef();
    document.addEventListener('click', this.closeAllianceInfo);
  }

  getSourceDataforExitPoll() {
    const { sourceData, isExitPoll } = this.props;
    if (
      (isExitPoll &&
        sourceData &&
        typeof sourceData === 'object' &&
        !this.state?.exitPollSource) ||
      !this.state?.selectedSource ||
      !this.state?.finalSourceData
    ) {
      const keys = Object.keys(sourceData);

      const finalKeys = [];
      const finalSourceData = {};
      keys.map(item => {
        const totalWonSeats = sourceData[item].reduce((total, source) => ({
          wscp: total.wscp + source.wscp,
        }));

        if (sourceData[item]) {
          finalSourceData[item] = JSON.parse(
            JSON.stringify(
              this.shiftOthToRight(
                this.getPartyListInSortedOrder(sourceData[item]),
              ),
            ),
          );
        }

        if (totalWonSeats.wscp > 0) {
          finalKeys.push(item);
        }
        return finalKeys;
      });

      if (finalKeys.length > 0) {
        this.state.exitPollSource = finalKeys;
        this.state.selectedSource = finalKeys[0];
        this.state.finalSourceData = finalSourceData;
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeAllianceInfo);
  }

  getSortedViewData = () => {
    const { isExitPoll, data } = this.props;
    if (
      !isExitPoll &&
      data &&
      Array.isArray(data.al_rslt) &&
      data.al_rslt[0] &&
      Array.isArray(data.pg_rslt) &&
      data.pg_rslt[0]
    ) {
      const alResult = data.pg_rslt[0];
      const prResult = data.al_rslt[0];
      const sortedPartyViewData = this.getPartyListInSortedOrder(prResult);
      const sortedAllianceViewData = this.getPartyListInSortedOrder(alResult);
      const sortedData = { sortedPartyViewData, sortedAllianceViewData };
      return sortedData;
    }

    return { sortedPartyViewData: [], sortedAllianceViewData: [] };
  };

  getCountOfLeadPlusWins = (data, totalSeats = 0) => {
    const { isExitPoll } = this.props;
    const seatCount = { winCount: 0, leadPlusWinCount: 0 };
    const party = Object.keys(data);
    for (let counter = 0; counter < party.length; counter += 1) {
      if (isExitPoll) {
        seatCount.leadPlusWinCount += data[party[counter]].wscp || 0;
      } else {
        seatCount.leadPlusWinCount +=
          data[party[counter]].ls + data[party[counter]].ws || 0;
        seatCount.winCount += data[party[counter]].ws || 0;
      }
    }
    if (isExitPoll) {
      seatCount.leadPlusWinCount = Math.round(
        seatCount.leadPlusWinCount * totalSeats / 100,
      );
      const disableSeatCount = this.props?.config?.disableSeatCount || 0;
      seatCount.leadPlusWinCount -=
        seatCount.leadPlusWinCount < disableSeatCount
          ? 0
          : disableSeatCount || 0;
    }
    return seatCount;
  };

  getActiveSeatCount = params => {
    const activeSeat = params?.config?.disableSeatCount
      ? params.data.ttl_seat - params.config.disableSeatCount
      : params.data.ttl_seat;
    return activeSeat;
  };

  getSelectedSourceData = () => {
    const { selectedSource } = this.state;
    const { sourceData } = this.props;
    if (!selectedSource) {
      return {};
    }
    return sourceData[selectedSource];
  };

  compareSeats = (a, b) => b.ls + b.ws - (a.ls + a.ws);

  compareSeatsExitPolls = (a, b) => b.wscp - a.wscp;

  getPartyListInSortedOrder = data => {
    const { isExitPoll } = this.props;
    if (data && (Array.isArray(data) || data.length > 0)) {
      if (!isExitPoll) {
        data.sort(this.compareSeats);
      }
      data.sort(this.compareSeatsExitPolls);
    }
    return data;
  };
  handleSourceOnChange = e => {
    this.setState({ selectedSource: e.target.value });
    // eslint-disable-next-line no-nested-ternary
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'exitpoll_widget',
      category: this.props?.config?.name || 'Assembly Elections',
      label: e.target.value,
    });
  };

  getSeries = (data, totalSeats) => {
    const { isExitPoll } = this.props;
    let val = {};
    let totalwls = 0;
    if (isExitPoll) {
      const series = [];
      if (Array.isArray(data) && data.length > 0) {
        const len = data.length;
        let firstNonZeroIndex = -1;
        for (let counter = len - 1; counter >= 0; counter -= 1) {
          val = {
            name: data[counter].an.toUpperCase(),
            data: [data[counter].wscp],
            color: data[counter].color || data[counter].cc,
          };
          totalwls += data[counter].wscp;

          if (data[counter].wscp > 0 && firstNonZeroIndex === -1) {
            firstNonZeroIndex = len - counter - 1;
          }
          series.push(val);
        }
      }

      const emptyData = {
        name: '',
        data: [
          totalSeats -
            totalwls * totalSeats / 100 +
            parseInt(this.props.config?.disableSeatCount || 0, 10),
        ],
        color: '#ececec',
      };
      series.unshift(emptyData);
      return series;
    }

    const series = [];
    if (Array.isArray(data) && data.length > 0) {
      const len = data.length;
      let firstNonZeroIndex = -1;
      for (let counter = len - 1; counter >= 0; counter -= 1) {
        val = {
          name: data[counter].an.toUpperCase(),
          data: [data[counter].ls + data[counter].ws],
          color: data[counter].color || data[counter].cc,
        };
        totalwls = totalwls + data[counter].ls + data[counter].ws;

        if (
          data[counter].ls + data[counter].ws > 0 &&
          firstNonZeroIndex === -1
        ) {
          firstNonZeroIndex = len - counter - 1;
        }
        series.push(val);
      }
    }

    const emptyData = {
      name: '',
      data: [totalSeats - totalwls],
      color: '#ececec',
    };
    series.unshift(emptyData);
    return series;
  };

  setActiveTab = event => {
    if (!event || !event.target) {
      return;
    }
    const tabNum = event.target.getAttribute('data-tab');
    this.setState({
      activeTab: tabNum ? Number(tabNum) : this.state.activeTab,
    });
  };

  closeAllianceInfo = e => {
    if (
      this.allianceInfoWrapperRef &&
      this.allianceInfoWrapperRef.current &&
      !this.allianceInfoWrapperRef.current.contains(e.target) &&
      this.state.showAllianceInfo
    ) {
      this.setState({ showAllianceInfo: false });
    }
  };

  toggleAllianceInfoPopup = allianceMap => {
    const { showAllianceInfo } = this.state;
    const { setAlliancePopUpData, isWapView } = this.props;
    if (isWapView) {
      setAlliancePopUpData(allianceMap);
    } else {
      this.setState({ showAllianceInfo: !showAllianceInfo });
    }
  };

  // eslint-disable-next-line camelcase
  getLeadingParty = (sortedPartyData, ttl_seat, isExitPoll, config) => {
    let leadingPartyObj = {};
    if (
      !Array.isArray(sortedPartyData) ||
      (sortedPartyData && sortedPartyData.length === 0) ||
      isExitPoll
    ) {
      return leadingPartyObj;
    }
    const majority = config?.overwriteMajority
      ? config.overwriteMajority
      : Math.floor(ttl_seat / 2) + 1;
    const [
      firstPartyData = { ws: 0, ls: 0 },
      secondPartyData = { ws: 0, ls: 0 },
    ] = [...sortedPartyData];
    const totalWonSeats = sortedPartyData.reduce((total, partyData) => ({
      ws: total.ws + partyData.ws,
    }));

    ttl_seat = config?.disableSeatCount
      ? ttl_seat - config?.disableSeatCount
      : ttl_seat;

    if (firstPartyData.ws >= majority) {
      //First party WON
      leadingPartyObj = {
        party: firstPartyData.an,
        text: 'WON',
        color: firstPartyData.cc,
      };
    } else if (totalWonSeats.ws === ttl_seat && firstPartyData.ws < majority) {
      //Election over but Hung assembly
      leadingPartyObj = {
        party: 'HUNG',
        text: 'NO MAJORITY',
        color: '#595959',
      };
    } else if (
      firstPartyData.ws + firstPartyData.ls > majority ||
      firstPartyData.ws + firstPartyData.ls >
        secondPartyData.ws + secondPartyData.ls
    ) {
      //First party LEADING
      leadingPartyObj = {
        party: firstPartyData.an,
        text: 'LEADING',
        color: firstPartyData.cc,
      };
    }
    if (leadingPartyObj.party === 'OTH') {
      leadingPartyObj = {};
    }
    return leadingPartyObj;
  };

  getAllianceMap = (data, allianceData) => {
    const partyData = this.getPartyListInSortedOrder(data.pr_rslt);
    const allianceMap = {};
    const finalAllianceMap = [];
    if (Array.isArray(partyData)) {
      partyData.map(item => {
        if (item.al_id && item.al_id !== 1) {
          allianceMap[item.al_id] = allianceMap[item.al_id] || [];
          allianceMap[item.al_id].push(item);
        }
        return allianceMap;
      });
    }
    if (Array.isArray(allianceData)) {
      allianceData.map(item => {
        if (allianceMap[item.a_id] && item.an) {
          finalAllianceMap.push({
            name: item.an,
            color: item.cc,
            data: allianceMap[item.a_id],
            totalSeats: item.ls + item.ws,
          });
        }
        return finalAllianceMap;
      });
    }
    return finalAllianceMap;
  };

  shiftOthToRight = sortedPartyData => {
    let index1;
    if (Array.isArray(sortedPartyData) && sortedPartyData.length > 1) {
      sortedPartyData.map((item, index) => {
        if (item.an === 'OTH') {
          index1 = index;
        }
        return index1;
      });
      if (index1 !== undefined) {
        const othData = sortedPartyData.splice(index1, 1);
        sortedPartyData.push(othData[0]);
      }
    }
    return sortedPartyData;
  };

  render() {
    // const cardno = cardcount;
    const {
      config,
      data,
      isExitPoll,
      starCandidateData,
      ExternalClass,
      showLeadsLabel,
      showResultWdtBtn,
      hideBattle,
      numberOfStates,
      isStarcnd,
      showViewCompleteCvgLink,
      hideStarCandidate,
      hideLiveblog,
      isIframeCssRequired,
      hideETheading,
      hideStateName,
      hideLink,
    } = this.props;

    const {
      exitPollSource,
      activeTab,
      showAllianceInfo,
      selectedSource,
      finalSourceData,
    } = this.state;
    const wrapperClass = classNames({
      [s.state]: true,
      [ExternalClass]: ExternalClass,
    });

    const {
      sortedPartyViewData,
      sortedAllianceViewData,
    } = this.getSortedViewData();
    if (!data || !data.ttl_seat) {
      return null;
    }

    const partyData = this.getSelectedSourceData();
    if (isExitPoll && !partyData) {
      return null;
    }

    const stateLandingPage = config && config.path;

    let sortedPartyData;
    let sortedAllianceData;

    if (isExitPoll) {
      sortedPartyData = this.getPartyListInSortedOrder(partyData);
    } else {
      sortedPartyData = sortedPartyViewData;
      sortedAllianceData = sortedAllianceViewData;
    }

    const leadingPartyObj =
      activeTab === 1
        ? this.getLeadingParty(
            sortedPartyData,
            data.ttl_seat,
            isExitPoll,
            config,
          )
        : this.getLeadingParty(
            sortedAllianceData,
            data.ttl_seat,
            isExitPoll,
            config,
          );

    const allianceMap = isExitPoll
      ? {}
      : this.getAllianceMap(data, sortedAllianceData);

    sortedPartyData = this.shiftOthToRight(sortedPartyData);
    sortedAllianceData = this.shiftOthToRight(sortedAllianceData);
    const seatData = this.getCountOfLeadPlusWins(
      sortedPartyData,
      data.ttl_seat,
    );
    const seatActive = this.getActiveSeatCount({ data, config });
    const infoMsgClass = this.props.infoMsgClass ? this.props.infoMsgClass : '';
    // isIframeCssRequired
    return (
      <div className={`${wrapperClass} ${s[infoMsgClass]} mcdStateWrap`}>
        <div className={`${s.stateHeader} ${s.flexbox}`}>
          <h4 className={s.stateName}>
            {hideLink ? (
              <a
                onClick={e => {
                  e.preventDefault();
                }}
                href={config.path}
                rel="nofollow noreferrer"
                // eslint-disable-next-line react/no-unknown-property
                frmappuse="1"
                target="_blank"
              >
                {config.name}
              </a>
            ) : (
              <Link
                className={hideStateName}
                href={config.path}
                data-newga={`click-ElectionWidget#${config.path}`}
                target="_blank"
                ga4Data={[
                  {
                    event: 'user_click',
                    type: 'exitpoll_widget',
                    category: config.name,
                    label: config.name,
                  },
                ]}
              >
                {config.name}
              </Link>
            )}
            {!isExitPoll && (
              <span
                className={`${s.leadWins} ${
                  hideStateName ? 'resultstatus' : ''
                }`}
              >
                {seatData.winCount === seatActive ? 'Results' : 'Leads + Wins'}
              </span>
            )}
          </h4>
          <div className={s.counts}>
            <strong>{seatData.leadPlusWinCount}</strong>/
            {data.ttl_seat}
          </div>
          {/* {isExitPoll && <div className={s.counts}>Seats: {seatActive}</div>} */}
        </div>

        {!config.hideAllianceView === '0' &&
          !isExitPoll && (
            <div className={s.partyInfo}>
              <ul onClick={this.setActiveTab}>
                <li className={activeTab === 1 ? s.active : ''} data-tab="1">
                  Party View
                </li>
                {config.hideAllianceView === '0' && (
                  <li className={activeTab === 2 ? s.active : ''} data-tab="2">
                    Alliance View
                  </li>
                )}
              </ul>
            </div>
          )}

        {isExitPoll && (
          <React.Fragment>
            <div
              className={`${s.sourceInfo} ${s.flexbox} ${
                !isIframeCssRequired ? 'sourcesas' : ''
              } `}
            >
              <span className={s.sourceText}>Source</span>
              <div
                className={`${s.selectBox} ${
                  exitPollSource && exitPollSource.length < 1
                    ? s.selectBoxDisable
                    : ``
                }`}
              >
                <select
                  onChange={e => this.handleSourceOnChange(e)}
                  disabled={!(exitPollSource && exitPollSource.length > 0)}
                >
                  {exitPollSource && exitPollSource.length > 0 ? (
                    exitPollSource.map(source => (
                      <option key={source} value={source}>
                        {source}
                      </option>
                    ))
                  ) : (
                    <option key="Select" value="Select" disabled selected>
                      Select
                    </option>
                  )}
                </select>
              </div>
            </div>
          </React.Fragment>
        )}
        {this.props.showbarchart &&
          !isStarcnd && (
            <div className={`${s.stateBar}`}>
              <React.Fragment>
                {isExitPoll ? (
                  <div className={s.stateBarInner}>
                    {exitPollSource &&
                      exitPollSource.length > 0 &&
                      exitPollSource.map(source => (
                        <div
                          style={{
                            display: `${
                              selectedSource === source ? 'block' : 'none'
                            }`,
                          }}
                        >
                          {finalSourceData[source] &&
                            finalSourceData[source].map(party => (
                              <DataBar
                                color={party.color}
                                name={party.an}
                                ws={party.ws}
                                wsc={party.wsc}
                                ttl_seat={data.ttl_seat}
                              />
                            ))}
                        </div>
                      ))}
                  </div>
                ) : (
                  <React.Fragment>
                    <div
                      className={`${s.stateBarInner} ${
                        activeTab === 1 ? s.show : s.hide
                      }`}
                    >
                      <RenderChartLoadable
                        type="stackedbar"
                        series={this.getSeries(sortedPartyData, data.ttl_seat)}
                      />
                    </div>
                    <div
                      className={`${s.stateBarInner} ${
                        activeTab === 2 ? s.show : s.hide
                      }`}
                    >
                      <RenderChartLoadable
                        type="stackedbar"
                        series={this.getSeries(
                          sortedAllianceData,
                          data.ttl_seat,
                        )}
                      />
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>

              {isExitPoll &&
                exitPollSource &&
                exitPollSource.length === 0 && (
                  <div className={s.stateBarInner}>
                    <RenderChartLoadable
                      type="stackedbar"
                      series={this.getSeries([], data.ttl_seat)}
                    />
                  </div>
                )}
              <div className={`${s.totalseatcount}  totalseatcount`}>
                <span>Seats:</span> <strong>{seatData.leadPlusWinCount}</strong>/{
                  data.ttl_seat
                }
              </div>
              <p className={`${s.majority}  majority`}>
                Majority{' '}
                <strong>
                  {config?.overwriteMajority
                    ? config.overwriteMajority
                    : Math.floor(data.ttl_seat / 2) + 1}
                </strong>
              </p>
              {showLeadsLabel && (
                <span className={s.leadWins}>
                  {seatData.winCount === seatActive ? 'Results' : 'L + W'}
                </span>
              )}
            </div>
          )}
        {!isStarcnd && (
          <div className={`${s.parties} parties`}>
            {isExitPoll && (
              <div className={s.exitPollMsgWrap}>
                {!(Array.isArray(exitPollSource) && exitPollSource.length) && (
                  <strong className={s.resultAwaited}>
                    Exit Poll Results Awaited
                  </strong>
                )}
                {config?.infoMsg && (
                  <p className={s.infomsg}>
                    <i className={s.icon}>i</i>
                    <span>{config?.infoMsg}</span>
                  </p>
                )}
              </div>
            )}
            {!isExitPoll && (
              <>
                <div className={s.electionFooter}>
                  {!showViewCompleteCvgLink && (
                    <div className="electionFooterResult">
                      <div className={s.partyResult}>
                        <strong
                          className={`${s.party} ${s.bjp}`}
                          style={{ color: leadingPartyObj.color }}
                        >
                          {leadingPartyObj.party}
                        </strong>{' '}
                        {leadingPartyObj.text}
                      </div>
                      {(!isIframeCssRequired || hideETheading) && (
                        <div
                          className={s.allianceInfo}
                          ref={this.allianceInfoWrapperRef}
                          style={{
                            display: activeTab === 2 ? 'block' : 'none',
                          }}
                        >
                          <span
                            onClick={() =>
                              this.toggleAllianceInfoPopup(allianceMap)
                            }
                          >
                            Alliance Info
                            <i className={s.icon}>i</i>
                          </span>

                          {showAllianceInfo && (
                            <AlliancePopup
                              allianceMap={allianceMap}
                              toggleAllianceInfoPopup={() =>
                                this.toggleAllianceInfoPopup(allianceMap)
                              }
                            />
                          )}
                        </div>
                      )}
                      {config?.infoMsg && (
                        <p className={s.infomsg}>
                          <i className={s.icon}>i</i>
                          <span>{config?.infoMsg}</span>
                        </p>
                      )}
                    </div>
                  )}
                  {showViewCompleteCvgLink && (
                    <div className={s.electionFooter}>
                      <div className={s.innerPages}>
                        <div className={s.partyResult}>
                          <strong
                            className={`${s.party} ${s.bjp}`}
                            style={{ color: leadingPartyObj.color }}
                          >
                            {leadingPartyObj.party}
                          </strong>{' '}
                          {leadingPartyObj.text}
                        </div>
                        {config?.infoMsg && (
                          <p className={s.infomsg}>
                            <i className={s.icon}>i</i>
                            <span>{config?.infoMsg}</span>
                          </p>
                        )}
                      </div>
                      <Link
                        to={`${stateLandingPage || '/'}`}
                        className={s.button}
                        data-ga={`${
                          typeof window === 'object' &&
                          window.location.pathname
                            .toLowerCase()
                            .match('/articleshow/')
                            ? 'Election_Result_AS_Widget|Click'
                            : 'Election_Result_Live_Blog_Widget|Click'
                        }`}
                        data-setgacategory
                      >
                        Complete coverage
                      </Link>
                    </div>
                  )}
                </div>
                {!this.props.showbarchart &&
                  showLeadsLabel && (
                    <span className={s.leadWins}>
                      {seatData.winCount === seatActive
                        ? 'Results'
                        : 'Leads + Wins'}
                    </span>
                  )}
              </>
            )}
          </div>
        )}

        {!isExitPoll &&
          !hideLiveblog &&
          // this.props.isWapView &&
          config.liveblog && (
            <div className={s.liveblog}>
              <LiveblogUpdates
                isWapView={this.props.isWapView}
                liveblogData={config.liveblog}
                storiesCount={1}
                // hideHeader
                hideContent
                themeClass
                electionStateName={config.name}
                hideBattle
              />
            </div>
          )}
        {(isStarcnd || (!hideBattle && !isExitPoll)) &&
          !hideStarCandidate &&
          starCandidateData &&
          starCandidateData?.cnt_rslt && (
            <ElectionBattle
              isWapView={this.props.isWapView}
              starCandidateData={starCandidateData?.cnt_rslt.filter(
                candidate =>
                  candidate.star === true &&
                  candidate.starMeta &&
                  candidate.starMeta.TOI === '1',
              )}
              showResultWdtBtn={showResultWdtBtn}
              state={config.key}
              numberOfStates={numberOfStates}
              isStarcnd={isStarcnd}
            />
          )}
      </div>
    );
  }
}

ElectionState.propTypes = {
  data: PropTypes.shape({}),
  config: PropTypes.shape({}).isRequired,
  sourceData: PropTypes.shape({}),
  isExitPoll: PropTypes.bool,
  isWapView: PropTypes.bool,
  ExternalClass: PropTypes.string,
  showbarchart: PropTypes.bool,
  infoMsgClass: PropTypes.string,
};
ElectionState.defaultProps = {
  data: {},
  sourceData: {},
  isExitPoll: false,
  isWapView: false,
  ExternalClass: '',
  showbarchart: true,
  infoMsgClass: '',
};

export default ElectionState;
